/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* The status of the resource security assignment. 
*/
export enum SecurityAssignmentStatus {
  SECURITY_UNSPECIFIED = 'UNSPECIFIED',
  SECURITY_ASSIGNED = 'ASSIGNED',
  SECURITY_NOT_ASSIGNED = 'NOT_ASSIGNED',
  SECURITY_EXCLUDED = 'EXCLUDED',
  SECURITY_UNSUPPORTED = 'UNSUPPORTED'
}
